import { useEffect, useRef } from 'react';
import _ from 'lodash';

import useEventBus, {
    canUseEventBus,
    EventBusName,
    FacialBusUtils,
    ScreenBusUtils,
} from '../../hooks/useEventBus';
import { useInitialFacialInfo } from '../../services/useFacialSDKService';

const useFacialRefreshSession = ({
    stepsInputData,
    customerInfo,
    stepUpToken,
    saveStepsInput,
    loanApplicationNumber,
}) => {
    const { facialInfoData: facialInfo = {} } = stepsInputData || {};
    const refeshPooling = useRef({
        status: false,
        callback: undefined,
    });

    const {
        onPost, rePost, data: facialInfoData, errors, loading, resetData,
    } = useInitialFacialInfo({
        stepUpToken,
        session: facialInfo.sessionToken,
        phoneNumber: stepsInputData.phoneNumber || customerInfo.phone,
        said: stepsInputData.said || customerInfo.said,
        loanApplicationNumber,
    });

    useEventBus(EventBusName.FACETEC_REFRESH_API_SESSION, (isRefreshSession, callback) => {
        if (refeshPooling.current.callback || !canUseEventBus({
            uniqueId: EventBusName.FACETEC_REFRESH_API_SESSION,
            seconds: 3,
        })) {
            return;
        }

        refeshPooling.current = {
            status: true,
            callback,
        };

        if (!isRefreshSession) {
            rePost(facialInfo.sessionToken);
            return;
        }
        saveStepsInput({ facialInfoData: undefined });
        rePost();
    });

    useEffect(() => {
        if (errors) {
            saveStepsInput({ facialInfoData: undefined });
            refeshPooling.current = {
                status: false,
                callback: undefined,
            };

            const errorMessage = errors.response || _.get(errors, 'cause.message');
            refeshPooling.current.status && FacialBusUtils.showErrorConfig(() => {
                ScreenBusUtils.showLoadingLazy();
                rePost();
            }, errorMessage);
        }
    }, [errors]);

    useEffect(() => {
        if (facialInfoData) {
            saveStepsInput({
                facialInfoData: {
                    ...facialInfoData,
                    sessionToken: facialInfoData.sessionToken || facialInfoData.session,
                },
            });

            if (refeshPooling.current.callback) {
                refeshPooling.current.callback();
            }

            refeshPooling.current = {
                status: false,
                callback: undefined,
            };
            resetData();
        }
    }, [facialInfoData, refeshPooling.current.callback]);

    return {
        onPost, rePost, facialInfoData, errors, loading,
    };
};

export default useFacialRefreshSession;
